import script from "./CircularIconButton.vue?vue&type=script&setup=true&lang=js"
export * from "./CircularIconButton.vue?vue&type=script&setup=true&lang=js"

import "./CircularIconButton.vue?vue&type=style&index=0&id=764d39db&scoped=true&lang=css"

import exportComponent from "/var/www/html/manual/expositores/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-764d39db"]])

export default __exports__